// extracted by mini-css-extract-plugin
export default {"container":"GoBackHeader_container__MA5rn","goBack":"GoBackHeader_goBack__PMhMY","logo":"GoBackHeader_logo__FSfn6","bigTitle":"GoBackHeader_bigTitle__dxn9A"};